import React from 'react';
import {classes, style} from './doppe-layout5-hero-photo.st.css';
import {DoppePageHeroPhoto} from "../../doppe-page-hero-photo/doppe-page-hero-photo";
import {RatioMaintainer} from "@wix/devzai-utils-react";

export const DoppeLayout5HeroPhoto = React.memo(function DoppeLayout5HeroPhoto (props: DoppeLayout5HeroPhoto.Props) {
    const {
        mediaResource,
        widthSpec,

        className,
        ...htmlAttributes
    } = props;

    return (
        <RatioMaintainer
            {...htmlAttributes}
            className={style(classes.root, className)}
            widthHeightRatio={1}
        >
            <DoppePageHeroPhoto
                className={style(classes.heroPhoto)}
                mediaResource={mediaResource}
                layoutSpec={{
                    widthHeightRatio: 1
                }}
                widthSpec={widthSpec}
            />
        </RatioMaintainer>
    );
});

export namespace DoppeLayout5HeroPhoto {

    export interface Props extends React.HTMLAttributes<any> {
        mediaResource: DoppePageHeroPhoto.Props['mediaResource'];
        widthSpec: DoppePageHeroPhoto.Props['widthSpec'];
    }
}
